import { Dispatch, SetStateAction, useContext, useEffect, useState } from "react"
import { PopupDeleteCategoriesWrapper } from "../popupDeleteCategories/styles"
import { IoClose } from "react-icons/io5"
import { FaExclamationTriangle } from "react-icons/fa"
import { useOwnerManagment } from "@services"
import { ToastMessageContext } from "@context/toast-message-cotnext"
import { useQueryClient } from "@tanstack/react-query"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"

interface IProps {
	onClose: () => void
	userId: number
	userTypeId: number
}

export default function PopupDeleteOwnerWithAccount({
	onClose,
	userId,
	userTypeId
}: IProps) {
	const { t } = useTranslation()
	const { showSuccess, showError } = useContext(ToastMessageContext)
	const queryClient = useQueryClient()
	const navigate = useNavigate()

	const handleNavigateToUserManagement = () => {
		navigate('/user-management')
		onClose()
	}

	return (
		<PopupDeleteCategoriesWrapper>
			<div className='popupContainer'>
				<div>
					<button onClick={onClose}>
						<IoClose />
					</button>
				</div>
				<div>
					<div style={{ color: '#FFA500' }}>
						<FaExclamationTriangle size={48} />
					</div>
					<p style={{ marginTop: '16px', marginBottom: '8px', fontWeight: 600 }}>
						{t('OwnerManagement.cannotDeleteOwnerWithAccount')}
					</p>
					<p style={{ fontSize: '14px', color: '#8E98A1', marginBottom: '16px' }}>
						{t('OwnerManagement.deleteOwnerAccountWarning')}
					</p>
				</div>
				<div>
					<button 
						type='button' 
						onClick={onClose}
						style={{
							padding: '12px 24px',
							borderRadius: '8px',
							border: '1px solid #FAFAFB',
							backgroundColor: '#FAFAFB',
							color: '#5B3FFF',
							cursor: 'pointer',
							fontWeight: 500
						}}
					>
						{t('OwnerManagement.cancel')}
					</button>
					<button 
						type='button' 
						onClick={handleNavigateToUserManagement}
						style={{
							padding: '12px 24px',
							borderRadius: '8px',
							border: '1px solid #5B3FFF',
							backgroundColor: '#5B3FFF',
							color: '#FFFFFF',
							cursor: 'pointer',
							fontWeight: 500,
							marginLeft: '8px'
						}}
					>
						{t('OwnerManagement.goToUserManagement')}
					</button>
				</div>
			</div>
		</PopupDeleteCategoriesWrapper>
	)
}
